module.exports = __webpack_public_path__ + "img/company_part3img1.78525db4.jpg";